import { useEffect, useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { loadStats as _loadStats } from 'redux/modules/stats';

const useStats = () => {
  const dispatch = useDispatch();

  const { count, loadedStats, loadingStats, ...rest } = useSelector(
    ({ stats }) => stats,
    shallowEqual
  );

  const loadStats = useCallback(() => dispatch(_loadStats()), [dispatch]);

  useEffect(() => {
    if (!count && !loadedStats && !loadingStats) {
      loadStats();
    }
  }, [count, loadStats]);

  return { count, loadedStats, loadingStats, ...rest };
};

export { useStats };
export default useStats;
